import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_VENDOR_DOWNLOAD_BOOKINGS, GET_VENDOR_DOWNLOAD_BOOKINGS_SUCCESS, GET_VENDOR_DOWNLOAD_BOOKINGS_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* downloadBookingsDump({ payload }) {
  console.log('payload?.headers?.codepayload?.headers?.code', payload?.headers?.code);
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/vendor/downloadsBookings`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        ...payload?.headers,
      },
      params: {
        ...payload?.urlParam,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: GET_VENDOR_DOWNLOAD_BOOKINGS_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: GET_VENDOR_DOWNLOAD_BOOKINGS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_VENDOR_DOWNLOAD_BOOKINGS_ERROR, payload: error });
  }
}

export function* watchDownloadBookingsDump() {
  yield takeEvery(GET_VENDOR_DOWNLOAD_BOOKINGS, downloadBookingsDump);
}

function* downloadBookingsDumpSaga() {
  yield all([fork(watchDownloadBookingsDump)]);
}

export default downloadBookingsDumpSaga;
